// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CreateInvoiceTermsMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateInvoiceTermsMetadataQuery = { __typename?: 'Query', customers: Array<{ __typename?: 'Customer', isHti?: boolean | null | undefined, id: string, name: string }>, regions: Array<{ __typename?: 'Region', id: string, name: string }> };

export type CreateInvoiceTerms_CustomerFragment = { __typename?: 'Customer', isHti?: boolean | null | undefined, id: string, name: string };

export type CreateInvoiceTerms_RegionFragment = { __typename?: 'Region', id: string, name: string };

export const CreateInvoiceTerms_CustomerFragmentDoc = gql`
    fragment CreateInvoiceTerms_Customer on Customer {
  ...Named
  isHti
}
    ${NamedFragmentDoc}`;
export const CreateInvoiceTerms_RegionFragmentDoc = gql`
    fragment CreateInvoiceTerms_Region on Region {
  ...Named
}
    ${NamedFragmentDoc}`;
export const CreateInvoiceTermsMetadataDocument = gql`
    query CreateInvoiceTermsMetadata {
  customers {
    ...CreateInvoiceTerms_Customer
  }
  regions {
    ...CreateInvoiceTerms_Region
  }
}
    ${CreateInvoiceTerms_CustomerFragmentDoc}
${CreateInvoiceTerms_RegionFragmentDoc}`;

/**
 * __useCreateInvoiceTermsMetadataQuery__
 *
 * To run a query within a React component, call `useCreateInvoiceTermsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceTermsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateInvoiceTermsMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateInvoiceTermsMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreateInvoiceTermsMetadataQuery, CreateInvoiceTermsMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateInvoiceTermsMetadataQuery, CreateInvoiceTermsMetadataQueryVariables>(CreateInvoiceTermsMetadataDocument, options);
      }
export function useCreateInvoiceTermsMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateInvoiceTermsMetadataQuery, CreateInvoiceTermsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateInvoiceTermsMetadataQuery, CreateInvoiceTermsMetadataQueryVariables>(CreateInvoiceTermsMetadataDocument, options);
        }
export function useCreateInvoiceTermsMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateInvoiceTermsMetadataQuery, CreateInvoiceTermsMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateInvoiceTermsMetadataQuery, CreateInvoiceTermsMetadataQueryVariables>(CreateInvoiceTermsMetadataDocument, options);
        }
export type CreateInvoiceTermsMetadataQueryHookResult = ReturnType<typeof useCreateInvoiceTermsMetadataQuery>;
export type CreateInvoiceTermsMetadataLazyQueryHookResult = ReturnType<typeof useCreateInvoiceTermsMetadataLazyQuery>;
export type CreateInvoiceTermsMetadataSuspenseQueryHookResult = ReturnType<typeof useCreateInvoiceTermsMetadataSuspenseQuery>;
export type CreateInvoiceTermsMetadataQueryResult = Apollo.QueryResult<CreateInvoiceTermsMetadataQuery, CreateInvoiceTermsMetadataQueryVariables>;